import { createSlice } from '@reduxjs/toolkit';

import { getPropertiesRoutine } from 'state/properties/properties.routines';

const initialState = {
    error: undefined,
    isFetchingProperties: false,
    properties: []
};

const propertiesSlice = createSlice({
    name: 'properties',
    initialState,
    extraReducers: {
        [getPropertiesRoutine.TRIGGER]: (state) => {
            state.error = undefined;
            state.isFetchingProperties = true;
        },
        [getPropertiesRoutine.SUCCESS]: (state, { payload }) => {
            state.error = undefined;
            state.properties = payload.properties;
            state.isFetchingProperties = false;
        },
        [getPropertiesRoutine.FAILURE]: (state) => {
            state.error = undefined;
            state.isFetchingProperties = false;
        }
    }
});

export default propertiesSlice.reducer;
